import { Observable } from 'rxjs';
import {
  ApiService,
  GET_ADMIN_GAMES_PATH,
  GET_ADMIN_GAMES_STATS_PATH,
  GET_ADMIN_KNOWN_REGIONS_PATH,
  GetAdminGamesQueryParams,
  GetAdminGamesResponse,
  GetAdminGamesStatsQueryParams,
  GetAdminGamesStatsResponse,
  GetAdminKnownRegionsResponse
} from '@core-http';
import { HttpParams } from '@angular/common/http';

export class AdminGamesService extends ApiService {
  getAllGames(queryParams: GetAdminGamesQueryParams = {}): Observable<GetAdminGamesResponse> {
    const params: HttpParams = this.fillQueryParams(queryParams);
    return this.httpClient.get<GetAdminGamesResponse>(`${this.env.apiUrl}${GET_ADMIN_GAMES_PATH}`, { params });
  }

  // Endpoint wspiera query param `forceRefresh: true` wymuszający odświeżenie cache po stronie backendu.
  // Użycie: getGamesStats({ statsDays: 7, forceRefresh: true })
  getGamesStats(queryParams: GetAdminGamesStatsQueryParams = {}): Observable<GetAdminGamesStatsResponse> {
    const params: HttpParams = this.fillQueryParams(queryParams);
    return this.httpClient.get<GetAdminGamesStatsResponse>(`${this.env.apiUrl}${GET_ADMIN_GAMES_STATS_PATH}`, {
      params
    });
  }

  getKnownRegions(): Observable<GetAdminKnownRegionsResponse> {
    return this.httpClient.get<GetAdminKnownRegionsResponse>(`${this.env.apiUrl}${GET_ADMIN_KNOWN_REGIONS_PATH}`);
  }
}
